import React from 'react';
import LegalLayout, { Section } from '../components/fancyplants/LegalLayout';

const TermsOfService = () => (
  <LegalLayout
    eyebrow="Legal"
    title="Terms of Service"
    intro="The plain-English rules for shopping with Fancy Plants."
    updated="May 2026"
  >
    <Section heading="Ordering">
      <p>
        When you place an order you're making an offer to buy. We confirm it by email once payment
        succeeds. Occasionally a plant sells out between adding to basket and checkout — if that
        happens we'll refund the affected item promptly.
      </p>
    </Section>

    <Section heading="Prices &amp; payment">
      <p>
        Prices are in euro and include VAT where applicable. Payment is handled securely by Stripe;
        we never see or store your full card details.
      </p>
    </Section>

    <Section heading="Delivery &amp; collection">
      <ul>
        <li>We deliver to most of Ireland. Delivery is free over €60; otherwise a fee is shown at checkout based on your Eircode.</li>
        <li>We ship early in the week so plants don't sit in a depot over the weekend.</li>
        <li>Click &amp; collect is available by half-hour slot from our glasshouse.</li>
      </ul>
    </Section>

    <Section heading="Our living-plant promise">
      <p>
        Plants are living things and can vary slightly from their photos. We pack every order with
        care and photograph it before it ships. If your plant arrives damaged or unhealthy, contact
        us within 48 hours with a photo and we'll repair, replace or refund it.
      </p>
    </Section>

    <Section heading="Returns">
      <p>
        Because plants are perishable, we handle issues case by case under the living-plant promise
        above rather than via standard returns. Gift cards are non-refundable but never expire.
      </p>
    </Section>

    <Section heading="Contact">
      <p>
        Questions about an order? Email{' '}
        <a href="mailto:hello@fancyplants.ie" className="link-underline">hello@fancyplants.ie</a> —
        a real person will reply.
      </p>
    </Section>
  </LegalLayout>
);

export default TermsOfService;
